import React from 'react';
import { Button } from './ui/button';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from './ui/dialog';
import { Bell, Users, Loader2, Send, MessageSquare, User } from 'lucide-react';

export default function GestaoLotesAlertarOps({
  open,
  onOpenChange,
  lote,
  operadores = [],
  onSetOperadores,
  onEnviar,
  alertando = false,
}) {
  const selecionados = operadores.filter((o) => o.selecionado);
  const todosSel = operadores.length > 0 && operadores.every((o) => o.selecionado);

  const toggleTodos = () => {
    onSetOperadores(operadores.map((o) => ({ ...o, selecionado: !todosSel })));
  };

  const toggleOp = (idx) => {
    onSetOperadores(operadores.map((o, i) => (i === idx ? { ...o, selecionado: !o.selecionado } : o)));
  };

  const setNota = (idx, nota) => {
    onSetOperadores(operadores.map((o, i) => (i === idx ? { ...o, nota } : o)));
  };

  return (
    <Dialog open={open} onOpenChange={(v) => {
      onOpenChange(v);
    }}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Bell className="h-5 w-5 text-amber-500" />
            Alertar Operadores
          </DialogTitle>
          <DialogDescription>
            Enviar alerta sobre o lote{' '}
            <strong>{lote?.codigo_lote || `L${lote?.numero_lote}`}</strong>
            {lote?.categoria_nome && ` (${lote.categoria_nome})`}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          {operadores.length === 0 ? (
            <div className="text-center py-8 text-stone-500">
              <Users className="h-12 w-12 mx-auto mb-3 opacity-30" />
              <p>Nenhum operador disponível para esta categoria</p>
            </div>
          ) : (
            <>
              <div className="flex items-center justify-between pb-3 border-b">
                <span className="text-sm text-stone-600">{selecionados.length} de {operadores.length} selecionados</span>
                <Button variant="outline" size="sm" onClick={toggleTodos}>
                  {todosSel ? 'Desselecionar Todos' : 'Selecionar Todos'}
                </Button>
              </div>
              <div className="space-y-3 max-h-[40vh] overflow-y-auto">
                {operadores.map((op, idx) => (
                  <div key={op.operador_id || idx}
                    className={`p-3 rounded-lg border transition-colors ${op.selecionado ? 'border-amber-300 bg-amber-50' : 'border-stone-200'}`}
                  >
                    <div className="flex items-start gap-3">
                      <input type="checkbox" checked={op.selecionado} onChange={() => toggleOp(idx)} className="mt-1 h-4 w-4 rounded border-stone-300" />
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-2">
                          <div className="w-8 h-8 rounded-full bg-stone-200 flex items-center justify-center">
                            <User className="h-4 w-4 text-stone-600" />
                          </div>
                          <div>
                            <p className="font-medium text-stone-800">{op.operador_nome}</p>
                            <span className="text-xs text-stone-500">@{op.operador_username}</span>
                          </div>
                        </div>
                        <div className="relative">
                          <MessageSquare className="absolute left-3 top-2.5 h-4 w-4 text-stone-400" />
                          <textarea
                            value={op.nota || ''}
                            onChange={(e) => setNota(idx, e.target.value)}
                            placeholder={`Nota para ${op.operador_nome}... (opcional)`}
                            className="w-full pl-10 pr-3 py-2 text-sm border rounded-lg resize-none"
                            rows={2}
                            disabled={!op.selecionado}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={onEnviar} disabled={alertando || selecionados.length === 0} className="bg-amber-600 hover:bg-amber-700">
            {alertando ? (
              <><Loader2 className="h-4 w-4 mr-2 animate-spin" />A enviar...</>
            ) : (
              <><Send className="h-4 w-4 mr-2" />Enviar Alertas ({selecionados.length})</>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
